import { render, staticRenderFns } from "./CardUser.vue?vue&type=template&id=beaa0e96&scoped=true"
import script from "./CardUser.vue?vue&type=script&lang=js"
export * from "./CardUser.vue?vue&type=script&lang=js"
import style0 from "./CardUser.vue?vue&type=style&index=0&id=beaa0e96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beaa0e96",
  null
  
)

export default component.exports